import CostService from "@/store/services/cost.service.js"
import TaxRateService from "@/store/services/taxrate.service.js"

export default {
  namespaced: true,
  state: {
    cost: null,
    costToEdit: {},
    costNumber: '',
    costFilters: {},
    tempCostList: [],
    tempCostListNext: null,
    companyTaxRates: null,
    refreshFlag: false,
  },
  getters: {
    getCost: state => state.cost,

    getCostToEdit: state => state.costToEdit,
    getCostNumber: state => state.costNumber,
    getCostFilter: state => state.costFilter,

    getTempCostList: state => state.tempCostList,
    getTempCostListNext: state => state.tempCostListNext,


    getCompanyTaxRates: state => state.companyTaxRates,
  },
  mutations: {
    SET_COST (state, cost) {
      state.cost = cost
    },
    setCostToEdit (state, costToEdit) {
      state.costToEdit = costToEdit;
    },
    setCostNumber (state, costNumber) {
      state.costNumber = costNumber;
    },
    setCostFilter (state, costFilter) {
      state.costFilter = costFilter;
    },
    setTempCostList (state, costList) {
      state.tempCostList = costList;
    },
    SET_COST_NUMBER (state, number) {
      state.costNumber = number;
    },
    SET_TEMP_COST_LIST (state, costList) {
      state.tempCostList = costList;
    },
    SET_TEMP_COST_LIST_NEXT (state, next) {
      state.tempCostListNext = next
    },
    SET_COMPANY_TAX_RATES (state, taxRates) {
      state.companyTaxRates = taxRates
    },
    REFRESH_COST_LIST (state) {
      state.refreshFlag = !state.refreshFlag
    },
  },
  actions: {
    loadCost ({ dispatch }, costId) {
      // dispatch('resetCostData')
      return Promise.all([
        dispatch('retrieveCost', costId)
      ])
    },
    retrieveCost ({ commit }, costId) {

      // CostService.retrieve(cost_id).then( (response) => {
      //   this.cost = response.data;
      //   this.$store.commit('costs/setCostNumber', this.cost.number);
      //   this.$store.commit('costs/setCostToEdit', this.cost);
      //   if (this.cost.image) {
      //       this.imageSrc = this.cost.image;
      //   } else {
      //       this.imageSrc = null;
      //   }
      // })

      return CostService.retrieve(costId).then((response) => {
        commit('SET_COST', response.data)
      })

    },
    createCost ({ commit }, cost) {
      return CostService.create(cost).then((response) => {
        commit('SET_COST', response.data)
      })
    },
    deleteCost (_, costId) {
      return CostService.destroy(costId)
    },
    getNextCostNumber({ commit }, year) {
      return CostService.getNextCostNumber({ 'year': year }).then((response) => {
        commit('SET_COST_NUMBER', response.data)
      })
    },
    // TODO duplicated on invoices.js store?
    loadCompanyTaxRates ({ commit, rootGetters }) {
      return TaxRateService.list({ 'company_profile': rootGetters['main/getCurrentCompany'].id }).then((response) => {
        // let data = $filter('orderBy')(response.data, "-value");
        let data = response.data
        for (let i = 0;i < data.length; i++) {
          data[i].name = data[i].taxrate+"%";
          data[i].order = data[i].taxrate;
        }
        commit('SET_COMPANY_TAX_RATES', response.data)
      })
    },
    resetCost ({ commit }) {
      commit('SET_COST', null)
    },
    // resetCostData ({ commit }) {
    // },
    loadCostsGlobalData ({ dispatch }) {
      return Promise.all([
        dispatch('loadCompanyTaxRates')
      ])
    }
  }
}
